'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/*
  Product 

  // -----------------------------------------------------
  // WE ARE IN THE PROCESS OF DEPRICATING THIS CLASS, USE 
  // ContentfulDOMHelper.JS CLASS INSTEAD 
  // -----------------------------------------------------

  Handles loading ui components for Product Page templates.

  Parameters:
    contentRef [string] (required):
      Reference to the content model property for the product template content.

    presenter [APIPresenter] (required):
      Reference to the APIPresenter in order to communicate with SOA and create data models.

*/

function Product(contentRef, presenter, node) {
  var _this3 = this;

  this._history = new History();
  this._presenter = presenter;
  this.contentRef = contentRef;
  this._analytics = new Analytics();
  this.valid = true;

  this._constructor = function () {
    this._contentModel = this._presenter.getModelProperty(this.contentRef);
    if (!this._contentModel._contentType) {
      console.warn('Product _constructor: _contentModel is invalid.');
      this.valid = false;
    }
  };

  // Components:
  this.loadText = function (container, content) {
    container.textContent = this._contentModel[content];
  };

  this.loadHTML = function (container, content) {
    container.innerHTML = this._contentModel[content];
  };

  this.loadMedia = function (container, customConfig, contentRef, callback) {
    if (contentRef === undefined) {
      var _contentModel = this._contentModel,
          media = _contentModel.media,
          contentType = _contentModel.media.file.contentType;
      // _contentModel = mogo.registry.mogoUI.repo.Portal.presenter.models.content;

      // TODO: REFACTOR LATER CAUSE NOT DRY

      if (contentType === 'undefined') {
        console.warn('loadMedia: Media asset not found.');
      } else if (contentType === 'application/json') {
        this.loadAnimation(container, media, customConfig, callback);
      } else {
        this.loadImage(container, media);
      }
    } else {
      // TODO: REFACTOR LATER CAUSE NOT DRY
      var media2 = this._contentModel[contentRef];
      var contentType2 = media2.file.contentType;

      if (contentType2 === 'undefined') {
        console.warn('loadMedia: Media asset not found.');
      } else if (contentType2 === 'application/json') {
        this.loadAnimation(container, media2, customConfig, callback);
      } else {
        this.loadImage(container, media2);
      }
    }
  };

  this.loadAnimation = function (container, media, customConfig, callback) {
    var _this = this;

    container.innerHTML = this._getAnimationHTML();

    var animationElement = container.querySelector('.js--animation');
    var url = media.file.url;

    var config = {
      loop: true,
      autoplay: true,
      url: url
    };
    if (customConfig) {
      _extends(config, customConfig);
    }
    var animationProps = {
      container: animationElement,
      loop: config.loop,
      autoplay: config.autoplay,
      path: config.url
    };

    if (config.preserveAspectRatio && config.preserveAspectRatio === 'none') {
      animationElement.addClass('media-item__full-screen-background');
      animationProps.rendererSettings = {
        preserveAspectRatio: 'none'
      };
    }

    if (typeof bodymovin === 'undefined') {
      $.ajax({
        url: '/member/assets/mogo-ui-lib-min/js/vendor/lottie.min.js?version=5.7.12',
        dataType: 'script',
        cache: true
      }).done(function () {
        _this.animation = bodymovin.loadAnimation(animationProps);
      });
    } else {
      this.animation = bodymovin.loadAnimation(animationProps);
    }

    // this.animation = bodymovin.loadAnimation(animationProps);

    // future functionality
    // this.animation.addEventListener('loopComplete', () => {
    //   console.log('loopComplete');
    // });

    var _ani = this.animation;
    this.animation.addEventListener('DOMLoaded', function () {
      // Callback for when we want to handle Lottie animation programatically
      // Passes the lottie animationObj back to the callback
      // at this point, animationObj is loaded completely
      if (callback) return callback();

      $(node).addClass('media-loaded');
      if (config.autoplay === false) {
        setTimeout(function () {
          _ani.play();
        }, 800);
      }
    });
  };

  this._getAnimationHTML = function () {
    return '<div class="mUP-common__media-item animation js--animation" />';
  };

  this.loadImage = function (container, media) {
    var url = media.file.url,
        title = media.title;


    container.innerHTML = this._getImageHTML(url, title);
  };

  this._getImageHTML = function (url, alt) {
    return '<img class="mUP-common__media-item js--image" src="' + url + '"  alt="' + alt + '" />';
  };

  this.loadPrimaryCta = function (container, actionId, callback, primaryCtaContent) {
    var _ref = primaryCtaContent || this._contentModel,
        _ref$primaryCta = _ref.primaryCta,
        buttonText = _ref$primaryCta.buttonText,
        configuration = _ref$primaryCta.configuration;

    var btnElement = primaryCtaContent ? container : container.querySelector('button');
    // const btnElement = container.querySelector('button');
    var targetId = this.getTargetId(configuration, actionId);

    // updated label text:
    if (btnElement.querySelector('span.label')) {
      btnElement.querySelector('span.label').innerText = buttonText;
    }

    // add listener
    if (callback) {
      btnElement.addEventListener('click', callback);
    } else {
      // TargetId should only exist when there's a path mapping (_paths: Product.shortcutMappings)
      var _targetId = this.getTargetId(configuration, actionId);
      btnElement.setAttribute('data-content-target-id', _targetId);
      btnElement.addEventListener('click', this.gotoTarget.bind(this, _targetId));
    }

    btnElement.classList.remove('hide');
    this._addDaiToCta(btnElement);
  };

  this.loadButtonList = function (container) {
    var _this2 = this;

    var type = container.classList.contains('list-button-solid') ? 'solid' : 'border'; // solid is articles, border is buttonList.
    var listContentRef = type === 'solid' ? this.contentRef + '.articleSet.articles' : this.contentRef + '.buttonList';
    var listContentArr = this._presenter.getModelProperty('' + listContentRef);

    var listHTML = '';

    if (listContentArr) {
      listContentArr.forEach(function (buttonObj, index) {
        listHTML += _this2._getButtonHTML(buttonObj, type);
      });

      container.innerHTML = listHTML;

      // addHistoryNode:
      var listLinks = container.querySelectorAll('a');
      listLinks.forEach(function (element) {
        return _this2._history.addHistoryNode(element, element.href);
      });
    }
  };

  this._getButtonHTML = function (buttonObj, type) {
    var classString = type === 'solid' ? 'solid' : 'border';
    var targetId = _this3.getTargetId(buttonObj.configuration);

    var href = type === 'solid' ? location.pathname + '/articles#' + targetId : Product.shortcutMappings[targetId];

    var displayText = type === 'solid' ? buttonObj.headline : buttonObj.buttonText;

    var listBtn = '<li class="list-button-' + classString + '__item">\n      <a class="list-button-' + classString + '__item-anchor" href="' + href + '" data-history="true">' + displayText + '\n        <svg class="svg-icon list-button-' + classString + '__item-svg" viewBox="0 0 32 32">\n          <use xlink:href="#icon-arrow-down-square"></use>\n        </svg>\n      </a>\n    </li>';

    return listBtn;
  };

  this._addDaiToCta = function (ctaElement) {
    var dai = 'Contentful-Contentful Navigation-' + this._contentModel.category.replace(/-/g, '=') + ' | ' + this._contentModel._contentType.sys.id.replace(/-/g, '=') + ' | ' + ctaElement.textContent.replace(/-/g, '=') + '-Navigation-Component';
    ctaElement.setAttribute('data-analytics-id', dai);
  };

  // Helpers

  /* 
    getTargetId
    TargetId should only exist when there's a path mapping (_paths: Product.shortcutMappings)
     Params:
      configObj(obj): found in contentfulObj.configuration
      actionId(string): found in contentfulObj.configuration.navigationActions[0].id 
  */
  this.getTargetId = function (configObj, actionId) {
    var actions = 'navigationActions'; // pick a default
    var lookupId = actionId || 'nav-action-1'; // pick a default

    var navActions = configObj[actions];
    var actionConfig = navActions.find(function (item) {
      return item.id === lookupId;
    });
    var actionTarget = actionConfig.targetId;

    // If Link contains [FSInsightLink], this is a token in contentful
    // and this part of the link needs to be replaced
    // with a value from backend
    // As of release-20210608, this is being used in Crypto Money Class (CryptoArticleGallery.js / ArticleGallery.js)
    // Article Number 3 (/member/dashboard/crypto/educational/articles#partnership-with-fsinsight)
    // FSInsight Ref: https://mogofintech.atlassian.net/browse/DV-2038
    // FSInsight Ref: https://mogofintech.atlassian.net/browse/DV-2034
    if (actionTarget && actionTarget.indexOf('[FSInsightLink]') > 0) {
      var FSInsightCouponCode = this._presenter.models.account.fs_insight_coupon_code; // from backend

      if (FSInsightCouponCode) {
        actionTarget = actionTarget.replace('[FSInsightLink]', FSInsightCouponCode);
      } else {
        console.warn('getTargetId - fs_insight_coupon_code not found');
      }
    }

    return actionTarget; // ex 'wealth-overview'
  };

  this.getSoaActionPath = function (configObj, actionId, modelPath) {
    var actions = 'navigationActions'; // pick a default
    var lookupId = actionId || 'soa-action-1'; // pick a default
    var navActions = configObj[actions];
    var actionConfig = navActions.find(function (item) {
      return item.id === lookupId;
    });
    var actionPath = modelPath ? modelPath + '.' + actionConfig.action : 'account.' + actionConfig.action;
    return this._presenter.hasAction(actionPath) ? actionPath : null;
  };

  this.gotoTarget = function (target) {
    if (Product.shortcutMappings[target]) {
      this._history.goToUrl(Product.shortcutMappings[target]);
    } else if (target.indexOf('https') > -1) {
      window.open(target);
    } else {
      console.warn('gotoTarget: shortcut not found.');
      this._history.goToUrl('/member/dashboard/home'); // don't leave the user in a jam
    }
  };

  this.pushPageViewAnalyticsEvent = function () {
    if (this._contentModel) {
      // see https://mogofintech.atlassian.net/wiki/spaces/DIG/pages/224101439/Contentful+Events
      // when a page includes a contentful piece, use the article title as the page title
      // the overview content type uses either statusTitle or headline for titles
      var articleTitle = this._contentModel.statusTitle || this._contentModel.headline;
      this._analytics.forcePushEvent('virtual-page-view', {
        Page: [decodeURI(articleTitle)]
      });
    } else {
      this._analytics.forcePushEvent('virtual-page-view');
    }
  };

  this.pushContentfulAnalyticsEvent = function () {
    this._analytics.forcePushEvent('contentful', {
      type: [this._contentModel._contentType.sys.id],
      category: [this._contentModel.category],
      content: [this._contentModel._id],
      version: [this._contentModel._updatedAt]
    });
  };

  this.setupLinkAction = function (linkElement, actionId, callback) {
    var _this4 = this;

    var config = this._contentModel.configuration;
    if (linkElement && config) {
      var targetId = this.getTargetId(config, actionId);
      if (callback) {
        this[targetId] = callback;
      }
      linkElement.addEventListener('click', function (e) {
        e.preventDefault();
        if (typeof _this4[targetId] === 'function') {
          _this4[targetId]();
        } else {
          _this4.gotoTarget(targetId);
        }
      });
    }
  };

  this.loadWaitlist = function (container, actionId, actionModelPath, actionPayload, isSuccess, callback) {
    var _this5 = this;

    if (!this._contentModel.waitlist) {
      console.warn('Waitlist: no waitlist content was found.');
      return;
    }
    var ctaContent = this._contentModel.waitlist.primaryCta;
    var msgContent = this._contentModel.waitlist.successMsg;
    if (actionId.indexOf('soa-action') > -1) {
      // perform soa action or display success message
      var msgElement = container.querySelector('.js--waitlist-success');
      var ctaElement = container.querySelector('.js--waitlist-cta');
      msgElement.innerText = msgContent;
      if (isSuccess) {
        // if already performed action successfully, display the message
        ctaElement.addClass('hide');
        msgElement.removeClass('hide');
      } else {
        // setup cta to perform soa action
        ctaElement.removeClass('hide');
        msgElement.addClass('hide');
        this.loadPrimaryCta(container, actionId, function () {
          var actionPath = _this5.getSoaActionPath(ctaContent.configuration, actionId, actionModelPath);
          if (actionPath) {
            _this5._presenter.performAction(actionPath, actionPayload, function (data, response) {
              if (response === 200) {
                ctaElement.addClass('hide');
                msgElement.removeClass('hide');
              }
              if (typeof callback === 'function') callback(data, response);
            });
          } else {
            console.warn('Waitlist: no soa action was found!');
          }
        }, this._contentModel.waitlist);
      }
    } else if (actionId.indexOf('nav-action') > -1) {
      // load a normal navigation cta
      this.loadPrimaryCta(container, actionId, callback);
    } else {
      console.warn('Waitlist: illegal action id was provided.');
    }
  };

  this.destroy = function () {
    if (this.animation) {
      // this.animation.removeEventListener('loopComplete');
      this.animation.destroy();
    }
  };

  this._constructor();
}